import state from "@/store/customer/state";
import actions from "@/store/customer/actions";
import mutations from "@/store/customer/mutations";
import getters from "@/store/customer/getters";

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
